/* istanbul ignore file */
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';
import { useLeadUrl } from 'domain/shared/lead';

const CompanyLinkField = ({ source, ...props }: FieldProps) => {
  const { getValue: getOpportunityId } = useFieldHelper({ source: 'opportunityId' });
  const { getValue: getLeadId } = useFieldHelper({ source: 'leadId' });
  const { getSingleEntityUrl: getLeadUrl } = useLeadUrl();
  const { getSingleEntityUrl: getOpportunityUrl } = useOpportunityUrl();

  const opportunityId = getOpportunityId();
  const leadId = getLeadId();

  return (
    <LinkField
      linkText={opportunityId || leadId}
      isInternal
      value={opportunityId ? getOpportunityUrl(opportunityId) : getLeadUrl(leadId)}
      {...props}
    />
  );
};

export default CompanyLinkField;
